import React from "react";
import { useQuery } from "react-query";

import { useCommonHooks } from "..";

export function useReasonRef() {
  const { apis } = useCommonHooks();
  const { data, isFetching, refetch } = useQuery(
    "ref-reasons",
    async () => {
      return apis.referential.reasons();
    },
    { staleTime: Infinity }
  );

  return {
    reasons: data,
    reasonsLoading: isFetching,
    refetchReasons: refetch,
  };
}
